app.controller('ProductController', ['$scope','$http','Config','$timeout','cart','toaster','product','helper','$window',
	function($scope,$http,Config,$timeout,cart,toaster,product,helper, $window){

	$scope.product = {};
	$scope.base_url = Config.base_url;
	$scope.productService = product;
	$scope.cartService = cart;
	$scope.cart = cart.getCart();
	$scope.qty=1;

	$scope.init = function(){
		width = 300;
		height = 300;
		zoom_width = 800;
		zoom_height = 800;
		$scope.helper = helper;

		$scope.product = $window.product;
		$timeout(function () {
			helper.hideLoader();
			init();
		}, 100);
		//$scope.productService.getProduct(width,height,zoom_height,zoom_width).then(function(response) {
		//	$scope.product = response.data;
		//	$timeout(function () {
		//		helper.hideLoader();
		//		init();
		//	}, 100);
		//}, function(response) {
		//	console.log(response);
		//});
	};

	$scope.incQty = function(){
		$scope.qty++;
	};

	$scope.decQty = function(){
		if($scope.qty>1){
			$scope.qty--;
		}
	};

	$scope.cartAdd = function(qty,sectionID){

		if (typeof sectionID == 'undefined') {
			sectionID = 4;
		}
		
        $http({
            method:'POST',
            url: Config.api_url+'counter?section_id='+sectionID+'&brand-key='+Config.brand_key,
            headers: {
                'authorization': Config.api_key
                }
        });

		//get product from the group
		cart.add($scope.product,qty);
		$scope.qty = 1;
		helper.showAddedtoCart();
	};

	$scope.changeQty = function(productID,$event){
        if($event){
            qty = $event.target.value;
            $scope.validateQty(qty,productID);
        }
    }

    $scope.validateQty = function(qty,productID){
        if(!cart.qtyValidation(qty)){
            $("input[name*='quantity").addClass('error');
            $(".help-block").show();
            $('.add_to_cart_btn').attr('disabled','disabled');
        }else{
            $("input[name*='quantity").removeClass('error');
            $(".help-block").hide();
            $('.add_to_cart_btn').removeAttr('disabled');
        }
    }

}]);



